/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import { OfficeImage } from '../shared/OfficeImage';
import { ServiceTableSection } from '../shared/ServiceTableSection';
import { OnlinePresentationSection } from '../shared/OnlinePresentationSection';
import { LegalInfoSection } from '../shared/LegalInfoSection';
import { NewsLetterSection } from '../shared/NewsLetterSection';
import { BuildingImage } from '../shared/BuildingImage';
import { TeamImage } from '../shared/TeamImage';
import { ErrorBoundary } from '../../ErrorBoundary';
import { useSanityHasFeaturedHomeNews } from '../../../sanity';
import { HomeFeaturedNews, ServiceSections } from './components';

const homePageTitle = (
  <Trans>
    Expertise, Savoir-faire & Indépendance au service de vos investissements
  </Trans>
);
const homepageIntro = (
  <Trans>
    Goldwasser Exchange est une société de bourse agréée par la Banque Nationale de Belgique.
  </Trans>
);

const css = ouiStyle.mediaQuery({
  paddingTop: [0, undefined, undefined, undefined, undefined, `${3.75 / 2}rem`],
});

export const Home = () => {
  const hasFeaturedNews = useSanityHasFeaturedHomeNews();
  return (
    <ErrorBoundary>
      <div
        css={css}
      >
        {hasFeaturedNews ? <HomeFeaturedNews /> : null}
        <ouiDom.HeadingSection.HeadingSection
          index={0}
          name="Home"
          container={ouiStyle.Constants.Container.full}
          illustrationPosition="before"
          paddingTop="none"
        >
          <TopModel<{
            textAlign?: ouiStyle.InStyle['textAlign'],
            paddingTop?: ouiStyle.InStyle['paddingTop'],
            paddingBottom?: ouiStyle.InStyle['paddingBottom'],
            paddingHorizontal?: ouiStyle.InStyle['paddingVertical'],
            styleAs: ouiDom.HeadingSection.HProps['styleAs'],
          }>
            name="HeadingSectionTitleContainer-1"
            textAlign="center"
            paddingHorizontal="simple"
            paddingTop="triple"
            paddingBottom="none"
            styleAs="h3"
          >
            {ouiDom.HeadingSection.DomH1}
          </TopModel>
          <TopModel<{
            textAlign?: ouiStyle.InStyle['textAlign'],
            color?: ouiStyle.InStyle['color'],
            fontSize?: ouiStyle.InStyle['fontSize'],
            paddingHorizontal?: ouiStyle.InStyle['paddingHorizontal'],
          }>
            name="HeadingSectionIntroContainer-Home"
            textAlign="center"
            color={ouiStyle.Constants.Colors.primary}
            paddingHorizontal="simple"
            fontSize="m"
          >
            {ouiDom.P.DomPContainer}
          </TopModel>
          <TopModel name="HeadingSectionTitleContent-Home">
            {homePageTitle}
          </TopModel>
          <TopModel name="HeadingSectionIntroContent-Home">
            {homepageIntro}
          </TopModel>
          <TopModel name="HeadingSectionIllustrationContent-Home">
            {BuildingImage}
          </TopModel>
          <ServiceSections />
          <OfficeImage />
          <ServiceTableSection />
          <OnlinePresentationSection />
          <LegalInfoSection />
          <NewsLetterSection
            index={7}
          />
          <TeamImage />
        </ouiDom.HeadingSection.HeadingSection>
      </div>
    </ErrorBoundary>
  );
};

Home.displayName = 'Home';
